import { DesignLanguage } from '@app/types';
import { isLanguageMatch, LanguageMatchProps } from './isLanguageMatch';

/**
 * Prefer language + TTS + VT, then language + TTS only.
 * Pass `voice` to attempt the VT-strict match first.
 */
export function findLanguageEntry(
  languages: DesignLanguage[],
  { voice, ...rest }: LanguageMatchProps
): DesignLanguage | undefined {
  if (voice !== undefined) {
    const withVoice = languages.find((entry) => (
      isLanguageMatch(entry, { ...rest, voice })
    ));
    if (withVoice) {
      return withVoice;
    }
  }
  return languages.find((entry) => isLanguageMatch(entry, rest));
}
